interface IConnections {
  [key: string]: string[];
}

export const isConnectionAvialable = (connections: IConnections) => {
  if (Object.keys(connections).length > 0) {
    return Object.keys(connections).some((item: string) => {
      const sources = connections[item];
      return sources !== null && sources.length > 0;
    });
  }
  return false;
};

export const canAccessRoute = (
  path: string,
  hasPermission: (id: string) => boolean,
  canAccessLiveEvents: boolean,
) => {
  const routes = [
    /\/sources\/\w*\/connect/,
    /\/sources\/\w*\/connectNewDestination/,
    /\/sources\/\w*\/linkTrackingPlan/,
    /\/destinations\/\w*\/connect/,
    /\/destinations\/\w*\/connectNewSource/,
    /\/destinations\/\w*\/clone/,
  ];
  if (routes.some((x) => x.test(path))) {
    const id = path.split('/')[2];
    return hasPermission(id);
  }

  const liveEventsRoutes = [
    /\/sources\/live\/\w*/,
    /\/destinations\/live\/\w*/,
    /\/transformations\/live\/\w*/,
  ];
  if (liveEventsRoutes.some((x) => x.test(path))) {
    return canAccessLiveEvents;
  }
  return true;
};
